import React from 'react';
import { ToastContainer } from 'react-toastify';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import { STAFFING_REPORTS, renderStaffingCell } from '../constants/staffingReportsConfig';
import { pickFilterParams } from '../constants/classesFiltersConfig';

const FILTER_IDS = ['venue_ownership_id'];

const buildFilterGroups = (venueOwnerships) => () => [{
  id: 'venue',
  label: 'Venue',
  filters: [{
    id: 'venue_ownership_id',
    label: 'Venue',
    type: 'checkbox',
    options: (venueOwnerships || []).map(o => ({ value: String(o.id), label: o.name })),
  }],
}];

function ReportingStaffingReportPage({ team, csrfToken, venueOwnerships, showWages, report: reportKey, ...props }) {
  const report = STAFFING_REPORTS[reportKey];
  const columns = report.columns.filter(c => showWages || !c.wages);

  const config = {
    pageTitle: report.title,
    pageSubtitle: report.description,
    sidebarKey: `staffing_${reportKey}`,
    defaultPreset: 'this_month',
    dateModeOptions: [{ key: 'order_date', label: 'Date' }],
    urlFilterIds: FILTER_IDS,
    sortTypes: SORT_TYPES,
    localStorageKey: (teamId) => `reportingStaffing_${reportKey}_${showWages ? 'wages' : 'hours'}_${teamId}`,
    firstColumnId: columns[0].id,
    defaultSortRules: [{ field: report.defaultSort, direction: 'desc' }],
    kpiFromDetailResponse: true,
    salesDataKey: null,
    venueSeriesKey: null,
    exportBasePath: (teamId) => `/teams/${teamId}/reporting/staffing/${reportKey}/export`,
    detailEndpoint: (teamId) => `/teams/${teamId}/reporting/staffing/${reportKey}/data.json`,
    detailResponseKey: 'rows',
    detailErrorMessage: `Failed to load ${report.title.toLowerCase()}.`,
    detailTableTitle: report.title,
    emptyMessage: 'No staffing in this range.',
    searchPlaceholder: report.searchPlaceholder,
    paginationLabel: report.itemLabel(2),
    itemLabel: report.itemLabel,
    buildKpiCards: (current) => report.kpis(current || {}, showWages),
    kpiGridColumns: report.kpis({}, showWages).length,
    overTimeKey: null,
    topCharts: [],
    groupByOptions: [],
    groupByDefault: null,
    renderNotice: () => <p className="text-muted mb-3" style={{ fontSize: 13 }}>{report.note}</p>,
    renderCellValue: renderStaffingCell,
    filterTitle: 'Filter staffing',
    filterSubtitle: 'Narrow the report to some venues.',
    columns,
    getDefaultVisibleColumns: () => columns.filter(c => c.defaultVisible),
    getDefaultHiddenColumns: () => columns.filter(c => !c.defaultVisible && !c.alwaysVisible),
    buildFilterGroups: buildFilterGroups(venueOwnerships),
    buildDetailApiFilters: pickFilterParams(FILTER_IDS),
  };

  return (
    <>
      <SalesDetailPage {...props} team={team} csrfToken={csrfToken} venueOwnerships={venueOwnerships} config={config} />
      <ToastContainer />
    </>
  );
}

export default ReportingStaffingReportPage;
